<template>
  <b-form-checkbox
    size="lg"
    v-model="modelValue"
    :value="checkedValue"
    :unchecked-value="uncheckedValue"
    :disabled="disabled"
    class="my-checkbox"
  >
    <slot></slot>
  </b-form-checkbox>
</template>

<script>
export default {
  props: {
    value: [Boolean, String],
    checkedValue: {
      type: [Boolean, String],
      default: true,
    },
    uncheckedValue: {
      type: [Boolean, String],
      default: false,
    },
    altcolor: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    modelValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.my-checkbox.b-custom-control-lg {
  @apply rtl:tw-pr-[1.875rem] rtl:tw-pl-0;

  ::v-deep .custom-control-label {
    @apply tw-flex tw-w-full tw-cursor-pointer;
  }

  ::v-deep .custom-control-label::before {
    @apply rtl:tw-left-0 rtl:tw-right-[-1.875rem];
    border-radius: 9999px;
    box-shadow: none !important;
  }

  ::v-deep .custom-control-label::after {
    @apply rtl:tw-left-0 rtl:tw-right-[-1.875rem];
  }

  ::v-deep .custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
    border-color: #b6b6b6;
  }
}
</style>
